import { create } from 'zustand'
import { cognitoAuthService } from '@/services/cognito-auth.service'
import { UserRole } from '@shared/types/roles'

interface User {
  id: string
  email: string
  role: UserRole
  firstName: string
  lastName: string
}

interface AuthState {
  user: User | null
  token: string | null
  refreshToken: string | null
  isLoading: boolean
  setAuth: (user: User, token: string, refreshToken: string) => void
  clearAuth: () => void
  logout: () => Promise<void>
  isAuthenticated: () => boolean
  loadUser: () => Promise<void>
}

export const useAuthStore = create<AuthState>()((set, get) => ({
  user: null,
  token: null,
  refreshToken: null,
  isLoading: true,

  setAuth: (user, token, refreshToken) => {
    set({ user, token, refreshToken, isLoading: false })
  },

  clearAuth: () => {
    set({ user: null, token: null, refreshToken: null, isLoading: false })
  },

  logout: async () => {
    await cognitoAuthService.logout()
    set({ user: null, token: null, refreshToken: null, isLoading: false })
  },

  isAuthenticated: () => {
    return !!get().user
  },

  loadUser: async () => {
    set({ isLoading: true })
    try {
      const user = await cognitoAuthService.getCurrentUser()
      const token = await cognitoAuthService.getToken()
      if (user && token) {
        set({ user, token, isLoading: false })
      } else {
        set({ user: null, token: null, refreshToken: null, isLoading: false })
      }
    } catch {
      set({ user: null, token: null, refreshToken: null, isLoading: false })
    }
  },
}))
